<section class="flex-column flex-0">
  <vdw-header [title]="'PLANNING.ADD_ITEM.SELECT_PRODUCTION_ORDERS.ADD_PRODUCTION_ORDERS_TO_RUN' | bmsTranslate" svgIcon="select-blue" [canShowClose]="true"></vdw-header>
  <article class="dialog-content flex-column gap-16 flex-0">
    <div class="flex-row flex-end-center">
      <vdw-filter (filteredTextChanged)="filterProductionOrders($event)"></vdw-filter>
    </div>
    <ag-grid-angular #productionOrdersGrid class="ag-theme-vdw" [gridOptions]="gridOptions" [rowData]="listOfProductionOrders"></ag-grid-angular>
  </article>
  <vdw-footer chooseEventName="GENERAL.ACTIONS.ADD" [centered]="true" [locked]="!canSelectProductionOrders()" [withCancelButton]="false" (chooseEvent)="selectProductionOrders()"></vdw-footer>
</section>
